export default __webpack_public_path__ + "static/media/webapp.e31445e6.png";